import styles from "./AllMedals.module.less";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CommonNavBar from "views/components/CommonNavBar";
import { getAllMedals } from "api/mine";
import { Toast } from "react-vant";

const AllMedals = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [userInfo, setUserInfo] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [medalList, setMedalList] = useState([]);
  // const tabs = ["升级勋章", "特殊成就", "限定勋章"];
  const tabs = ["升级勋章"];

  const getAvatarUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    return `${process.env.REACT_APP_API_CDN}${url.startsWith("/") ? "" : "/"}${url}`;
  };

  const fetchMedalsData = async (tabIndex) => {
    Toast.loading({
      message: "加载中...",
      forbidClick: false,
      duration: 0,
    });
    try {
      const type = tabIndex + 1; // 1, 2, 3
      const res = await getAllMedals(type);
      if (res.code === 200 && res.data) {
        setUserInfo(res.data.user_info || {});
        setTotalCount(res.data.total_medal_count || 0);
        setMedalList(res.data.list || []);
      }
    } catch (error) {
      console.error("Failed to fetch medals data:", error);
    } finally {
      Toast.clear();
    }
  };

  useEffect(() => {
    fetchMedalsData(activeTab);
  }, [activeTab]);

  return (
    <div className={styles["all-medals-container"]}>
      <div className={styles["top-bg-bar"]}></div>
      <CommonNavBar
        title="全部勋章"
        onClickBack={() => navigate(-1)}
        backgroundColor="transparent"
        isTop={true}
      />
      <div className={styles["header-section"]}>
        <div className={styles["header-left"]}>
          {userInfo.avatar ? (
            <img className={styles["avatar"]} src={getAvatarUrl(userInfo.avatar)} alt="avatar" />
          ) : (
            <div className={styles["avatar-placeholder"]}></div>
          )}
          <div className={styles["user-name"]}>{userInfo.english_name || "\u00A0"}</div>
          <div className={styles["medal-count"]}>共{totalCount}枚勋章</div>
          <div 
            className={styles["history-btn"]}
            onClick={() => navigate("/mine/myMedal")}
          >
            我的勋章历程
            <img src={require("@/images/mine/my-medal/next-icon.png")} alt="next" />
          </div>
        </div>
        <div className={styles["header-right"]}>
          <img className={styles["top-icon"]} src={require("@/images/mine/my-medal/top-icon.png")} alt="top icon" />
        </div>
      </div>

      <div className={styles["tabs-section"]}>
        {tabs.map((tab, index) => (
          <div 
            key={index}
            className={`${styles["tab-item"]} ${activeTab === index ? styles["active"] : ""}`}
            onClick={() => setActiveTab(index)}
          >
            <div className={styles["tab-content"]}>
              <div className={styles["tab-text-container"]}>
                <div className={styles["tab-text"]}>{tab}</div>
              </div>
              <div className={styles["tab-line"]}></div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles["list-section"]}>
        {medalList.map((item, index) => (
          <div 
            key={item.medal_code || index} 
            className={styles["medal-item"]}
            onClick={() => navigate(`/mine/medalDetail?category_id=${item.category_id}&show_level=${item.level || item.show_level}`)}
          >
            {item.is_new === 1 && (
              <img className={styles["new-icon"]} src={require("@/images/mine/my-medal/new-icon.png")} alt="new" />
            )}
            <img className={styles["medal-icon"]} src={item.icon} alt={item.show_title} />
            <div className={styles["medal-title"]}>{item.show_title}</div>
            <div className={styles["medal-time"]}>
              {item.is_earned === 1 ? item.obtained_date_text : item.earned_user_count_text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllMedals;
